"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TeamValidator = require("./TeamValidator");
Object.keys(_TeamValidator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TeamValidator[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TeamValidator[key];
    }
  });
});